/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuMultiSelectList_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterPeriod_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuFilterPeriod_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuMultiSelectList_searchBrowse$ref,
  +$refType: SbSharedRefineMenuFilterPeriod_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterPeriod_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectList_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e44a28bab0b1593b513f43cc8477709d';
module.exports = node;
